export default __webpack_public_path__ + "c51cfb160117134f0f75afa33678fc97.jpeg";